// Based on https://start.vaadin.com/app
import { configure } from 'mobx'
configure({ enforceActions: 'never' })

// DI has to be first
import './di'
import './vaadin'
import './views'
import './app'